angular.module('unica_auth.auth_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// AUTH LOGIN
		.state('app.auth_login', {
			url: '/auth/extra/generali/login',
			views: {
				'mainContent': {
					templateUrl: './modules/auth/templates/login.html',
					controller: 'LoginController'
				}
			}
		})

		// AUTH NAM LOGIN
		.state('app.auth_nam', {
			url: '/auth/nam',
			views: {
				'mainContent': {
					templateUrl: './modules/auth/templates/nam.html',
					controller: 'NamController'
				}
			}
		})

		// AUTH ERROR
		.state('app.auth_error', {
			url: '/auth/error',
			views: {
				'mainContent': {
					templateUrl: './modules/auth/templates/error.html',
					controller: 'NamController'
				}
			}
		})

		// AUTH LOGOUT
		.state('app.auth_logout', {
			url: '/auth/logout',
			views: {
				'mainContent': {
					templateUrl: './modules/auth/templates/logout.html',
					controller: 'LogoutController'
				}
			},
			params: {
				need_auth: true
			}
		})

		// AUTH FORGOTTEN PASSWORD
		.state('app.auth_forgotten_password', {
			url: '/auth/forgotten-password',
			views: {
				'mainContent': {
					templateUrl: './modules/auth/templates/forgotten-password.html',
					controller: 'ForgottenPasswordController'
				}
			}
		})

		// AUTH LOGOUT
		.state('app.auth_logout_success', {
			url: '/auth/logout/success',
			views: {
				'mainContent': {
					templateUrl: './modules/auth/templates/logout-success.html',
					controller: 'LogoutSuccessController'
				}
			}
		});


});

